import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar.jsx';
import { api } from '../api/client.js';

export default function AppViewer() {
  const { id } = useParams();
  const [app, setApp] = useState(null);
  const [launchUrl, setLaunchUrl] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/api/apps');
        const found = data.apps.find((a) => a.id === id);
        if (!found) return setError('App not found or you do not have access.');
        setApp(found);

        if (found.authType === 'SSO') {
          const { data: sso } = await api.post('/api/sso/token', { appId: id });
          setLaunchUrl(sso.redirectUrl);
        } else {
          setLaunchUrl(found.url);
        }
      } catch (err) {
        setError(err.response?.data?.error || err.message);
      }
    })();
  }, [id]);

  return (
    <>
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between mb-3">
          <h1 className="text-lg font-medium">{app?.name || 'Loading…'}</h1>
          <button onClick={() => navigate('/')} className="text-sm text-muted hover:text-ink">
            ← Back to launcher
          </button>
        </div>
        {error && <div className="text-sm text-red-600 p-4">{error}</div>}
        {launchUrl && app && (
          <div className="bg-white border border-border rounded-xl p-8 text-center">
            <p className="text-sm text-muted mb-4">App URL ready to launch</p>
            <p className="text-xs text-muted mb-4 font-mono">{launchUrl}</p>
            <a
              href={launchUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-ink text-white px-6 py-2 rounded-lg text-sm hover:opacity-90"
            >
              Open {app.name} ↗
            </a>
            <p className="text-xs text-muted mt-6">
              In production, this would render the app inside a sandboxed iframe.
              For now we open in a new tab so you can use the seeded example URLs.
            </p>
          </div>
        )}
      </main>
    </>
  );
}
